import request from '@/util/request'
import {
  JSON_CONFIG,
  getAPILangParam
} from '@/util/helper.js'

export function getAllRecord (patientId) {
  return request({
    url: `/record/${patientId}`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getRecordOfDate (patientId, date) {
  return request({
    url: `/record/${patientId}/${date}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function getRecordOfExercise (patientId, exerciseId) {
  return request({
    url: `/record/${patientId}/exercise/${exerciseId}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function getAchievedRateOfExercise (patientId, rehabId, startDate, endDate) {
  return request({
    url: `/record/${patientId}/rehab/${rehabId}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      sDate: startDate,
      eDate: endDate
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/patient/record.js